import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ConfigModule, FeaturesConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { KbSoftwareDetailsPageComponent } from './kb-software-details-page/kb-software-details-page.component';
import { KbSoftwareConfirmationPageComponent } from './kb-software-confirmation-page/kb-software-confirmation-page.component';
import { KbSoftwareNeosearchPageComponent } from './kb-software-neosearch-page/kb-software-neosearch-page.component';
import { KbSoftWareSearchPageComponent } from './kb-soft-ware-search-page/kb-soft-ware-search-page.component';
import { RouterModule } from '@angular/router';
import {
  AtMessageModule,
  IconModule,
  ItemCounterModule,
  ListNavigationModule,
  MediaModule,
  OutletModule,
  PageComponentModule,
  SpinnerModule,
  StarRatingModule,
  ProductListModule,
} from '@spartacus/storefront';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FacetNavigationModule } from '../facet-navigation/facet-navigation.module';
import { KbSoftwareGridItemModule } from '../kb-product-list/kb-software-grid-item/kb-software-grid-item.module';
import { KbSoftwareListItemModule } from '../kb-product-list/kb-software-list-item/kb-software-list-item.module';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { SoftwareTermsUsePopupComponent } from './soft-ware-request-form-page/software-terms-use-popup/software-terms-use-popup.component';
import { MatDialogModule } from '@angular/material/dialog';
import { RecaptchaModule, RecaptchaFormsModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { SoftWareRequestFormPageComponent } from './soft-ware-request-form-page/soft-ware-request-form-page.component';
import { KbPaginationModule } from '../kb-pagination/kb-pagination/kb-pagination.module';
import { EnvironmentService } from 'src/app/services/environment.service';

@NgModule({
  declarations: [
    KbSoftwareNeosearchPageComponent,
    SoftWareRequestFormPageComponent,
    KbSoftwareConfirmationPageComponent,
    KbSoftWareSearchPageComponent,
    KbSoftwareDetailsPageComponent,
    SoftwareTermsUsePopupComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    AtMessageModule,
    FeaturesConfigModule,
    IconModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    MediaModule,
    OutletModule,
    PageComponentModule,
    RouterModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    ProductListModule,
    KbSoftwareGridItemModule,
    KbSoftwareListItemModule,
    FacetNavigationModule,
    MatDialogModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    KbPaginationModule,
    ConfigModule.withConfig({
      cmsComponents: {
        // ---Software DetailsPage-----   softwareDetailsPage
        SoftwareDetailsFlexComponent: {
          component: KbSoftwareDetailsPageComponent,
          guards: [SecureGuard],
        },
        //---softwareLibrarySearch----   softwareLibrary
        SoftwareLibraryFlexComponent: {
          component: KbSoftWareSearchPageComponent,
          guards: [SecureGuard],
        },
        //=-------softwareConfirmationPage     -----    softwareConfirmationPage
        SoftwareConfirmationFlexComponent: {
          component: KbSoftwareConfirmationPageComponent,
          guards: [SecureGuard],
        },
        //----softwareRequest---    softwareRequestFormPage
        SoftwareRequestFormFlexComponent: {
          component: SoftWareRequestFormPageComponent,
          guards: [SecureGuard],
        },
        SoftwareSearchFlexComponent: {
          component: KbSoftwareNeosearchPageComponent,
          guards: [SecureGuard],
        },
      },
    }),
  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useFactory: (config: EnvironmentService): RecaptchaSettings => {
        return { siteKey: config.getConfig().googleReCaptchaKey };
      },
      deps: [EnvironmentService],
    },
  ],
})
export class KbCustomSoftWareSearchModule {}
